/** Calendar month YYYY-MM is completed when today is in a later month (local date). */
export function isCompletedCalendarMonth(yyyyMm: string, asOf: Date = new Date()): boolean {
  const match = /^(\d{4})-(\d{2})$/.exec(yyyyMm.trim())
  if (!match) {
    // Unparseable month — keep treating associated rows as errors.
    return true
  }
  const year = Number(match[1])
  const month = Number(match[2])
  if (!Number.isFinite(year) || month < 1 || month > 12) {
    return true
  }
  const asYear = asOf.getFullYear()
  const asMonth = asOf.getMonth() + 1
  return year < asYear || (year === asYear && month < asMonth)
}

/** Whether an uploads/ledger error for this month should surface in badges and row styling. */
export function uploadsErrorVisibleForMonth(
  month: string | null | undefined,
  asOf: Date = new Date()
): boolean {
  if (month == null || month.trim() === '') return true
  return isCompletedCalendarMonth(month, asOf)
}
